import React, { FunctionComponent, useContext } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { AddToMergeListButton } from "../../../../../common/components/AddToMergeListButton";
import { ContentVersionSource } from "../../../../../common/types/ContentVersionSource";
import { validateVersionsMergeability } from "../../../../../common/utils/validateVersionsMergeability";
import { EpisodeVersionDetails } from "../../../../TvSeriesDetails";
import { EpisodeVersionListContext } from "../context/EpisodeVersionListProvider";
import { EpisodeVersionListingItem } from "../EpisodeVersionListingItem";

export const AddEpisodeVersionToMergeListButton: FunctionComponent<ListActionButtonProps> = (
    props: ListActionButtonProps
) => {
    const { versionsToMerge, listingItems, addVersionToMergeList, selectedEpisode } = useContext(
        EpisodeVersionListContext
    );

    const mergeButtonDisabled = (): boolean => {
        const item = listingItems.find((listingItem: EpisodeVersionListingItem) => listingItem.id === props.itemId);

        if (!item) return true;

        if (item.source === ContentVersionSource.Trailer) return true;

        if (versionsToMerge.some((version: EpisodeVersionListingItem) => version.id === item.id)) return true;

        const candidates =
            selectedEpisode.versions.filter((versionDetails: EpisodeVersionDetails) =>
                [...versionsToMerge, item].some(
                    (listingItem: EpisodeVersionListingItem) => listingItem.id === versionDetails.id
                )
            ) ?? [];

        const areMergeable = !validateVersionsMergeability(candidates);

        return areMergeable || !!props.disabled;
    };

    const handleClick = () => {
        const item = listingItems.find((listingItem: EpisodeVersionListingItem) => listingItem.id === props.itemId);
        addVersionToMergeList(item);
    };

    return <AddToMergeListButton disabled={mergeButtonDisabled()} onClick={handleClick} />;
};
